import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  closePipeline: {
    id: 'frontbucket.pipelines.common.pipelineStatus.closePipeline',
    description: 'Text for close pipeline modal',
    defaultMessage: 'Close',
  },

  stopPipelineModalBody: {
    id: 'frontbucket.pipelines.common.pipelineStatus.stopPipelineModalBody',
    description: 'Body text for the stop pipeline modal',
    defaultMessage: 'Are you sure you want to stop pipeline?',
  },

  cancelButton: {
    id: 'frontbucket.pipelines.common.pipelineStatus.cancelButton',
    description: 'Text for the cancel button',
    defaultMessage: 'Cancel',
  },
  stopButton: {
    id: 'frontbucket.pipelines.common.pipelineStatus.stopButton',
    description: 'Text for the stop button',
    defaultMessage: 'Stop',
  },
  stopFinalStepButton: {
    id: 'frontbucket.pipelines.common.pipelineStatus.stopFinalStepButton',
    description: 'Text for the stop final step button',
    defaultMessage: 'Stop final step',
  },
  rerunStoppedSteps: {
    id: 'frontbucket.pipelines.common.pipelineStatus.rerunStoppedSteps',
    description: 'Text for rerunning stopped steps',
    defaultMessage: 'Rerun stopped steps',
  },
  rerunFailedSteps: {
    id: 'frontbucket.pipelines.common.pipelineStatus.rerunFailedSteps',
    description: 'Text for rerunning failed steps',
    defaultMessage: 'Rerun failed steps',
  },
  rerun: {
    id: 'frontbucket.pipelines.common.pipelineStatus.rerun',
    description: 'Text for rerunning',
    defaultMessage: 'Rerun',
  },
  rerunEntirePipeline: {
    id: 'frontbucket.pipelines.common.pipelineStatus.rerunEntirePipeline',
    description: 'Text for rerunning the entire pipeline',
    defaultMessage: 'Rerun entire pipeline',
  },
});
